import marketingImg from "../Imgs/marketing.jpg";
import sitioweb from "../Imgs/sitio-web.jpg"
import ordenamiento from "../Imgs/ordenamiento-datos.jpg"
import captacion from "../Imgs/captacion.jpg"
import diagnostico from "../Imgs/diagnostico.jpg"
import planeamiento from "../Imgs/planeamiento.jpg"


export const CardPorServiciosData = [
  {
    id: "sitio-web",
    titulo: "Sitio Web",
    descripcion:
      "Creación y desarrollo de sitios web profesionales para tu negocio.",
    imagen: sitioweb,
    color: "#147dcc",
  },

  {
    id: "ordenamiento-datos",
    titulo: "Ordenamiento de Datos",
    descripcion:
      "Organización de Excel, productos, imágenes y bases de datos.",
    imagen: ordenamiento,
    color: "#3d6b50",
  },

  {
    id: "marketing",
    titulo: "Marketing Publicitario",
    descripcion:
      "Contenido, publicidad y estrategias para aumentar tu presencia digital.",
    imagen: marketingImg,
    color: "#891594",
  },

  {
    id: "captacion-clientes",
    titulo: "Método de Captación de Clientes",
    descripcion:
      "Convertí personas interesadas en consultas y oportunidades comerciales.",
    imagen: captacion,
    color: "#d66a35",
  },

  {
    id: "diagnostico",
    titulo: "Diagnóstico Empresarial",
    descripcion:
      "Analizamos tus procesos para detectar oportunidades de mejora.",
    imagen: diagnostico,
    color: "#536c91",
  },

  {
    id: "planeamiento",
    titulo: "Planeamiento para Crecer",
    descripcion:
      "Definimos procesos, herramientas y prioridades para acompañar el crecimiento.",
    imagen: planeamiento,
    color: "#5d2470",
  },
];